import { AddCircleOutline, Close } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import {
  BaseOperation,
  OPERATION_TYPES,
} from 'pages/BusinessProfile/Contracts/Portfolios/Components/CreatePortfolio/Components/Inputs/OperationAssociation/operations';
import React, { useMemo, useState } from 'react';

import OperationsDialog from './OperationsDialog';

interface OperationAssociationProps {
  value: string;
  type: string | undefined;
  onChange: (value: string) => void;
  businessIdentifier: string | undefined;
}

const OperationAssociation: React.FC<OperationAssociationProps> = ({
  value,
  type,
  onChange,
  businessIdentifier,
}) => {
  if (!type) return null;
  const [openDialog, setOpenDialog] = useState(false);
  const [operation, setOperation] = useState<BaseOperation | null>(null);

  const operationLabel = useMemo(() => {
    if (!value || !type) return '';
    const config = OPERATION_TYPES[type];
    return config ? config.getLabel(operation) : '';
  }, [value, type]);

  const config = useMemo(() => {
    if (!type) return null;
    return OPERATION_TYPES[type];
  }, [type]);

  const handleSelectOperation = (operation: BaseOperation) => {
    setOperation(operation);
    onChange(operation.id.toString());
  };

  return (
    <>
      <TextField
        fullWidth
        label={config?.label || 'Operación'}
        value={operationLabel}
        placeholder={`Seleccionar ${config?.label || 'operación'}`}
        onClick={() => setOpenDialog(true)}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              {value ? (
                <IconButton
                  edge="end"
                  onClick={(e) => {
                    e.stopPropagation();
                    onChange('');
                  }}
                  size="small"
                >
                  <Close />
                </IconButton>
              ) : (
                <IconButton
                  edge="end"
                  onClick={() => setOpenDialog(true)}
                  size="small"
                >
                  <AddCircleOutline />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
        sx={{ cursor: 'pointer' }}
      />
      <OperationsDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        operationType={type}
        onSelectOperation={handleSelectOperation}
        businessIdentifier={businessIdentifier}
      />
    </>
  );
};

export default OperationAssociation;
